import { Settings } from 'lucide-react';
import { type ComponentType, createElement } from 'react';
import { BoxesIcon } from '@/components/ui/boxes';
import { CartIcon } from '@/components/ui/cart';
import { FileTextIcon } from '@/components/ui/file-text';
import { ShipIcon } from '@/components/ui/ship';

export type NavIconProps = {
  className?: string;
  isAnimating?: boolean;
};

export type NavItem = {
  id: string;
  href: string;
  icon?: ComponentType<NavIconProps>;
  labelKey: string;
};

export type NavSection = {
  id: string;
  labelKey: string;
  items: NavItem[];
};

function ConfigurationIcon({ className }: NavIconProps) {
  return createElement(Settings, { className });
}

export const navigation: NavSection[] = [
  {
    id: 'main',
    labelKey: '',
    items: [
      {
        id: 'purchasePlanning',
        href: '/purchase-planning',
        icon: FileTextIcon,
        labelKey: 'PurchasePlanning',
      },
      {
        id: 'lotSizings',
        href: '/lot-sizings',
        icon: BoxesIcon,
        labelKey: 'LotSizings',
      },
      {
        id: 'purchaseOrders',
        href: '/purchase-orders',
        icon: CartIcon,
        labelKey: 'PurchaseOrders',
      },
      {
        id: 'transits',
        href: '/transits',
        icon: ShipIcon,
        labelKey: 'Transits',
      },
      {
        id: 'configuration',
        href: '/configuration',
        icon: ConfigurationIcon,
        labelKey: 'Configuration',
      },
    ],
  },
];
